
import { Component, Vue } from 'vue-property-decorator'
import mobileFirst from './mobileFirst.vue'
import mobileBindOn from './mobileBindOn.vue'
@Component({
  components:{
    mobileFirst,
    mobileBindOn
  }
})
export default class BindEmail extends Vue {
  private show :boolean = true
  parentShow(){
    this.show = false
  }
}
